import { render, staticRenderFns } from "./waybillManagement.vue?vue&type=template&id=46580be6&scoped=true&"
import script from "./waybillManagement.vue?vue&type=script&lang=js&"
export * from "./waybillManagement.vue?vue&type=script&lang=js&"
import style0 from "./waybillManagement.vue?vue&type=style&index=0&id=46580be6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46580be6",
  null
  
)

export default component.exports